import { Fsk8sHeader } from "../Fsk8sPage/Header";
import { useClusterDashboardContext } from "../Fsk8sPage/Table/context";

const KubernetesLensHeader = () => {
  const { timeRange, setTimeRange } = useClusterDashboardContext();

  return <Fsk8sHeader timeRange={timeRange} onChangeTimeRange={setTimeRange} />;
};

export default KubernetesLensHeader;
